<template>
  <div class="activity-view">
    <ActivityList :actions="actions"
                  :actions-to-hide-details-button="actionsToHideDetailsButton"
                  :for="'receipt'"
                  :value-visualizer="valueVisualizer">
      <template v-slot:text="{activity}">
        {{ actions[activity.action] ? actions[activity.action].message : activity.action }}
      </template>

      <template slot="modal-body(create.receipt_commission)" slot-scope="{activity}">
        <activity-commissions-table :activity="activity"/>
      </template>

      <template slot="modal-body(update.receipt_commission)" slot-scope="{activity}">
        <activity-commissions-table :activity="activity"/>
      </template>

      <template slot="modal-body(update.receipt_miscellaneous_charges)" slot-scope="{activity}">
        <activity-miscellaneous-table :activity="activity"/>
      </template>

    </ActivityList>
  </div>
</template>

<script>
  import ActivityList from "../../../activities/ActivityList";
  import {createNamespacedHelpers} from "vuex";
  import ActivityCommissionsTable from "./ActivityCommissionsTable";
  import receiptsActivityHelper from "@/modules/receipt/view/activities/receiptsActivityHelper";
  import ActivityMiscellaneousTable from "@/modules/receipt/view/activities/ActivityMiscellaneousTable";

  const {mapState} = createNamespacedHelpers('receipts');
  const {mapState: mapStateBranch} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateDepartment} = createNamespacedHelpers('setup/department');
  const {mapActions: activityMapActions} = createNamespacedHelpers('activities');

  export default {
    name: "ActivitiesView",
    components: {ActivityMiscellaneousTable, ActivityCommissionsTable, ActivityList},
    data: () => {
      return {
        actions: receiptsActivityHelper.actions,
        actionsToHideDetailsButton: [
          'reserved', 'return_note_signed_by_staff', 'return_note_signed_by_buyer', 'signed_by_buyer',
          'signed_by_staff', 'receipt_contract_regenerated', 'pre_receipt_contract_regenerated'
        ]
      };
    },
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt,
        ...mapStateBranch(['branches']),
        ...mapStateDepartment(['departments']),
      })
    },
    methods: {
      ...activityMapActions(['setActivitiesParams']),
      valueVisualizer: receiptsActivityHelper.valueVisualizer
    },
    beforeMount() {
      this.setActivitiesParams({object: this.receipt, source: 'receipt'})
    }
  }

</script>

<style lang="scss">

</style>
